<template>
	<div class="Tasks">
		<el-card class="box-card mt-2">
			<div class="text-right">
				<el-dropdown trigger="click" class="text-xs" @command="opeDialogOnCommand">
					<el-button
						size="mini"
						type="submit"
						class="action-btn p-2 text-xs font-bold"
					>
						<i class="el-icon-plus el-icon--right"></i>
						Add
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="CREATE_TASK_LIST">Create Task List</el-dropdown-item>
						<el-dropdown-item command="ASSIGN_TASK">Assign Task</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>

			<div class="campaignTable mt-4">
				<table>
					<thead>
						<th>TASKS</th>
						<th>ASSIGNED TO</th>
						<th>DATE</th>
						<th>TIME</th>
						<th>FRIQUENCY</th>
						<th>STATUS</th>
						<th></th>
					</thead>
					<tbody>
						<tr>
							<td>Bar Setup</td>
							<td>
								<div>Ajay Patel</div>
								<div class="mt-2">Bartender</div>
							</td>
							<td>
								<div><b>Start</b> - 2020/08/25</div>
								<div class="mt-2"><b>End</b> - 2020/08/25</div>
							</td>
							<td>
								<div><b>Start</b> - 2020/08/25</div>
								<div class="mt-2"><b>End</b> - 2020/08/25</div>
							</td>
							<td>All Days</td>
							<td>
								<div class="status-badge">Active</div>
							</td>
							<td>
								<img
									src="../../../../../assets/images/edit.png"
									class="cursor-pointer mr-2"
									width="22"
									alt
								/>
								<img
									src="../../../../../assets/images/delete-icon.png"
									class="cursor-pointer"
									width="22"
									alt
								/>
							</td>
						</tr>
						<tr>
							<td>Stock Count</td>
							<td>
								<div>Ajay Patel</div>
								<div>Bartender</div>
							</td>
							<td>
								Recurring
							</td>
							<td>
								<div><b>Start</b> - 2020/08/25</div>
								<div class="mt-2"><b>End</b> - 2020/08/25</div>
							</td>
							<td>Sunday</td>
							<td>
								<div class="status-badge">Active</div>
							</td>
							<td>
								<img
									src="../../../../../assets/images/edit.png"
									class="cursor-pointer mr-2"
									width="22"
									alt
								/>
								<img
									src="../../../../../assets/images/delete-icon.png"
									class="cursor-pointer"
									width="22"
									alt
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!-- create task category dialog -->
      <el-dialog
				title="Create Task Category"
				:visible.sync="create_task_dialog_visible"
        :before-close="closeCreateTaskDialog"
				width="55%"
			>
				<div>
          <el-row :gutter="15">
            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <label class="block">Department</label>
              <el-select v-model="select_department" placeholder="Select Department" name="Select Department" style="width: 100%;">
                <el-option
                  v-for="item in department_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <span v-show="errors.has('Select Department')" class="text-red-dark text-xs">
                {{ errors.first("Select Department") }}
              </span>
            </el-col>

            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <label class="block">Function</label>
              <el-select v-model="select_function" placeholder="Select Function" name="Select Function" multiple style="width: 100%;">
                <el-option
                  v-for="item in function_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <span v-show="errors.has('Select Function')" class="text-red-dark text-xs">
                {{ errors.first("Select Department") }}
              </span>
            </el-col>
          </el-row>

          <el-row :gutter="15" class="mt-5">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <label class="block">Task Category</label>
              <el-input v-model="task_category" placeholder="Select Task Category" name="Task Category" style="width: 100%;">
              </el-input>

              <span v-show="errors.has('Task Category')" class="text-red-dark text-xs">
                {{ errors.first("Select Department") }}
              </span>
            </el-col>
          </el-row>

          <el-row :gutter="15" class="mt-5">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <label class="block">Description <span class="font-xs" style="color: #ddd;">(optional)</span></label>
              <el-input v-model="description" type="textarea" :rows="3" placeholder="Enter task Description" style="width: 100%;">
              </el-input>
            </el-col>
          </el-row>

          <el-row :gutter="15" class="mt-5">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <label class="block">Checklist <span class="font-xs" style="color: #ddd;">(optional)</span></label>
              <div v-for="(item, check_index) in check_list" :key="check_index">
                <el-input v-model="item.label" :placeholder="'Step '+(check_index+1)" style="width: 100%;" class="mb-4">
                </el-input>
              </div>

              <el-button class="action-btn mt-2" size="mini" @click="addMoreCheckList()">ADD MORE</el-button>
            </el-col>
          </el-row>
				</div>

        <div slot="footer" class="dialog-footer text-right mt-4">
          <el-button
            class="action-btn text-sm"
            size="mini"
            @click="create_task_dialog_visible = false"
            >CANCEL</el-button
          >
          <el-button
            class="action-btn text-sm"
            size="mini"
            @click="saveCreateTaskCategory()"
            >ADD</el-button
          >
        </div>
			</el-dialog>

			<!-- assign task dialog -->
      <el-dialog
				title="Assign Task"
				:visible.sync="assign_task_dialog_visible"
        :before-close="closeAssignTaskDialog"
				width="55%"
			>
				<div>
          <el-row :gutter="20" class="mt-5">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <label>Department</label>
            </el-col>
            <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
              <el-select v-model="select_department" placeholder="Select Department" style="width: 50%;">
              <el-option
                v-for="item in department_list"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            </el-col>
          </el-row>

          <el-row :gutter="20" class="mt-5">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <label>Select Task</label>
            </el-col>
            <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
              <el-select v-model="select_task" placeholder="Select Task" style="width: 80%;">
                <el-option
                  v-for="item in task_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-row>

          <el-row :gutter="20" class="mt-5">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <label>Assign To</label>
            </el-col>
            <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
              <el-select v-model="assign_employee" placeholder="Select Employee" multiple style="width: 50%;">
                <el-option
                  v-for="item in employee_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-row>

            <el-row :gutter="20" class="mt-5">
              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                <label>Frequency</label>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-radio v-model="frequency" label="recurring">Recurring</el-radio>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-radio v-model="frequency" label="limited">Limited Period</el-radio>
              </el-col>
            </el-row>

            <el-row :gutter="20" class="mt-5" v-if="frequency != 'limited'">
              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                <label>Select Days</label>
              </el-col>

              <el-col :xs="18" :sm="18" :md="6" :lg="6" :xl="6">
                <el-radio v-model="days" label="all" @change="discountable_days = []">All Days</el-radio>
              </el-col>

              <el-col :xs="18" :sm="18" :md="6" :lg="6" :xl="6">
                <div class="flex items-center">
                  <el-radio v-model="days" label="" style="margin-right: 5px;"></el-radio>

                  <el-select v-model="discountable_days" multiple style="width: 100%" placeholder="Select Day" size="medium" :disabled="days == 'all'">
                    <el-option v-for="(day, day_index) in day_list" :key="day_index" :label="day.title" :value="day.value"></el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20" class="mt-5">
              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                <label>Select Date</label>
              </el-col>
              <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                <el-date-picker
                  v-model="from_date"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="Start Date"
                  size="medium"
                  style="width: 100%;"
                  v-validate="'required'"
                  name="From Date"
                />
              </el-col>
              <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                <el-date-picker
                  v-model="to_date"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="End Date"
                  size="medium"
                  style="width: 100%;"
                  v-validate="'required'"
                  name="To Date"
                />
              </el-col>
            </el-row>

            <el-row :gutter="20" class="mt-5">
              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                <label>Select Time</label>
              </el-col>
              <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                <el-time-select style="width: 100%" placeholder="Start Time" v-model="start_time" size="medium" v-validate="'required'" name="Start Time"
                :picker-options="{
                  start: '00:00',
                  end: '23:00'
                }"></el-time-select>
              </el-col>
              <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                <el-time-select style="width: 100%" placeholder="End Time" v-model="end_time" size="medium" v-validate="'required'" name="End Time"
                :picker-options="{
                  start: '00:00',
                  end: '23:00'
                }"></el-time-select>
              </el-col>
            </el-row>

            <el-row :gutter="15" class="mt-5">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="flex justify-between items-center">
                  <label class="block">Description <span class="font-xs" style="color: #ddd;">(optional)</span></label>

                  <input type="file" ref="file" style="display: none;">
                  <div class="font-bold cursor-pointer" @click="$refs.file.click()">
                    <i class="el-icon-paperclip" style="font-size: 18px;"></i>
                    <span style="font-size: 13px;">
                      Add Attachment
                    </span>
                  </div>
                </div>
                <el-input v-model="description" type="textarea" :rows="3" placeholder="Enter task Description" style="width: 100%;">
                </el-input>
              </el-col>
            </el-row>
				</div>

        <div slot="footer" class="dialog-footer text-right mt-4">
          <el-button
            class="action-btn text-sm"
            size="mini"
            @click="assign_task_dialog_visible = false"
            >CANCEL</el-button
          >
          <el-button
            class="action-btn text-sm"
            size="mini"
            >ADD</el-button
          >
        </div>
			</el-dialog>
		</el-card>
	</div>
</template>
<script>
import { mapState } from "vuex";
import LabourPalnningService from "../../../../../services/labourPalnningService";
export default {
	name: "Tasks",
	data(){
		return {
			create_task_dialog_visible: false,
			assign_task_dialog_visible: false,
			select_department: "",
			select_function: [],
			discountable_days: [],
			days: "",
			task_category: "",
			description: "",
			select_task: "",
			assign_employee: [],
			frequency: "recurring",
			from_date: "",
			to_date: "",
			start_time: "",
			end_time: "",
			department_list: [],
			function_list: [
        {
          label: 'Function 1',
          value: 1
        },
        {
          label: 'Function 2',
          value: 2
        }
			],
			check_list: [
				{
					label: "",
					serial_no: 1
				},
				{
					label: "",
					serial_no: 2
				}
			],
			task_list: [
        {
          label: 'Task 1',
          value: 1
        },
        {
          label: 'Task 2',
          value: 2
        }
			],
			employee_list: [
        {
          label: 'Emp 1',
          value: 1
        },
        {
          label: 'Emp 2',
          value: 2
        }
			],
			day_list: [
        {
          title: 'Monday',
          value: 0
        },{
          title: 'Tuesday',
          value: 1
        },
        {
          title: 'Wednesday',
          value: 2
        },{
          title: 'Thursday',
          value: 3
        },{
          title: 'Friday',
          value: 4
        },{
          title: 'Saturday',
          value: 5
        },{
          title: 'Sunday',
          value: 6
        }
			]
		};
  },
  mounted() {
    // api to get store departments
    this.getStoreDepartmentList();
  },
	methods: {
		opeDialogOnCommand(command) {
			if (command == "CREATE_TASK_LIST") {
				this.create_task_dialog_visible = true;
			} else if (command == "ASSIGN_TASK") {
				this.assign_task_dialog_visible = true;
			}
		},
		closeCreateTaskDialog() {
			this.create_task_dialog_visible = false;
		},
		closeAssignTaskDialog() {
			this.assign_task_dialog_visible = false;
		},
		addMoreCheckList() {
			this.check_list.push({ check: "", serial_no: this.check_list.length });
    },
		getStoreDepartmentList() {
      if(this.storeName){
        let params = {};
        params.outlet_id = this.storeName;
        LabourPalnningService.getStoreDepartments(params)
          .then(response => {
            let res = JSON.parse(response.data);
            this.department_list = res;
          })
          .catch(
            function(error) {
              console.log(error);
            }.bind(this)
          );
      }
    },
		saveCreateTaskCategory() {
      this.$validator.validateAll().then(result => {
        if(result){
          let params = {};
          params.id = "";
          params.store = this.storeName;
          params.name = this.task_category;
          params.department = this.select_department;
          params.functions = this.select_function;
          // params.checklist = [{"label" : "clean the table", "serial_no" : 1}, {"label" : "arrange the table", "serial_no" : 2}]
          params.checklist = this.check_list;

          LabourPalnningService.saveCreateTaskCategory(params)
            .then(res => {
              if (res.status == 200) {
                console.log("saveCreateTaskCategory", JSON.parse(res.data));
                this.create_task_dialog_visible = false;

                this.$notify.success({
                  title: "Success",
                  message: "Task category created..!"
                });
              } else {
                this.create_task_dialog_visible = false;
              }
            })
            .catch(
              function(err) {
                console.log(err);
                this.create_task_dialog_visible = false;
              }.bind(this)
            );
        }
      })
		}
	},
	computed: {
		...mapState("LabourPlanning", ["storeName"])
	},
};
</script>
<style lang="scss" scoped>
@import url("./Task.scss");
</style>
